import { readB2BInternals } from '../../utils/internal.mjs';
import { safeLocalStorage } from '../../utils/storage.mjs';
import { useInternalStorage } from '../../utils/useInternalStorage.mjs';
import { useStytchClient } from './useStytchClient.mjs';

const useSessionStorage = (key, defaultValue)=>{
    const stytch = useStytchClient();
    const { publicToken } = readB2BInternals(stytch);
    return useInternalStorage(safeLocalStorage, publicToken, key, defaultValue);
};

export { useSessionStorage };
//# sourceMappingURL=useSessionStorage.mjs.map
